import $api from "@/frontend/shared/api/axios";

export async function deleteRevisionLogo() {
  await $api.delete(`/founder-revisions/logo`);
}
